module.exports = __webpack_public_path__ + "cd0a053d.png";